/* ============================================================
   NOVALE CLOTHING - novale.js
   Sticky-nav background tint, mobile menu, cart, toast
   ============================================================ */

(function () {
  'use strict';

  /* NAV BACKGROUND ON SCROLL */
  var nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* MOBILE MENU */
  var hamburger = document.querySelector('.nav-hamburger');
  var mobileMenu = document.querySelector('.mobile-menu');
  var menuClose = document.querySelector('.mobile-menu-close');

  function openMenu() {
    if (mobileMenu) mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'true');
      var hb = hamburger.querySelector('.icon-hamburger');
      var cl = hamburger.querySelector('.icon-close');
      if (hb) hb.style.display = 'none';
      if (cl) cl.style.display = 'block';
    }
  }
  function closeMenu() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
      var hb = hamburger.querySelector('.icon-hamburger');
      var cl = hamburger.querySelector('.icon-close');
      if (hb) hb.style.display = 'block';
      if (cl) cl.style.display = 'none';
    }
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (mobileMenu && mobileMenu.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }
  if (menuClose) menuClose.addEventListener('click', closeMenu);

  // Close mobile menu when a nav link is tapped
  document.querySelectorAll('.mobile-menu-link').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });

  /* CART COUNT */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () { /* ignore */ });
  }
  updateCartCount();

  /* ADD TO CART */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        updateCartCount();
        showToast((item.product_title || 'Item') + ' added to bag');
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalLabel || 'Add to Bag';
        }, 1800);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalLabel || 'Add to Bag';
      });
  });

  /* TOAST */
  function showToast(msg) {
    var toast = document.getElementById('novale-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'novale-toast';
      toast.style.cssText = [
        'position:fixed', 'bottom:32px', 'left:50%',
        'transform:translateX(-50%)',
        'background:var(--color-black)', 'color:var(--color-white)',
        'padding:16px 28px', 'font-family:var(--font-display)',
        'font-size:13px', 'font-weight:700', 'letter-spacing:0.1em',
        'text-transform:uppercase', 'display:flex', 'align-items:center',
        'gap:12px', 'z-index:9999', 'max-width:calc(100vw - 48px)',
        'box-sizing:border-box', 'transition:opacity 0.3s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> ' + msg;
    toast.style.opacity = '1';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.style.opacity = '0'; }, 3000);
  }

})();
